<template>
	<div class="mask" :class="{'mask-open':open}">
		<slot></slot>
	</div>
</template>

<script>
	export default{
		props:["open"]
	}
</script>

<style>
	.mask{
		z-index: 50;
		display: none;
		position: fixed;
		top:0;
		left:0;
		height:100%;
		width:100%;
		background: rgba(0,0,0,0.5);
	}
	.mask-open{
		display: block;
	}
	.mask>*{
		position: absolute;
		top:50%;
		left:50%;
		transform: translate(-50%,-50%);
	}
</style>


// WEBPACK FOOTER //
// src/components/mask/mask.vue